import { Link } from 'react-router-dom';
import { BROCHURE_PDF, ENROLL_FORM, PARTNER_FORM } from '../forms';

const quickLinks = [
  { label: 'Home', href: '/#home' },
  { label: 'About Us', href: '/#about' },
  { label: 'Programs', href: '/#programs' },
  { label: 'Roadmap', href: '/#journey' },
  { label: 'Colleges', href: '/#benefits' },
];

const resources = [
  { label: 'Blog', href: '#' },
  { label: 'Career Guide', href: '#' },
  { label: 'Download Brochure', href: BROCHURE_PDF, download: 'FutureLeadX-Brochure.pdf' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms & Conditions', href: '#' },
];

const socialLinks = [
  // {
  //   label: 'Facebook',
  //   href: '#',
  //   icon: (
  //     <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6" aria-hidden="true">
  //       <path d="M13.5 22v-8h2.7l.4-3.1h-3.1V9c0-.9.3-1.5 1.6-1.5H16.8V4.7C16.4 4.6 15.3 4.5 14 4.5c-2.7 0-4.5 1.6-4.5 4.6v2.8H7v3.1h2.5V22h4z" />
  //     </svg>
  //   ),
  // },
  // {
  //   label: 'Instagram',
  //   href: '#',
  //   icon: (
  //     <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6" aria-hidden="true">
  //       <path d="M7.5 3h9A4.5 4.5 0 0121 7.5v9A4.5 4.5 0 0116.5 21h-9A4.5 4.5 0 013 16.5v-9A4.5 4.5 0 017.5 3zm0 1.8A2.7 2.7 0 004.8 7.5v9a2.7 2.7 0 002.7 2.7h9a2.7 2.7 0 002.7-2.7v-9a2.7 2.7 0 00-2.7-2.7h-9zM12 8.2A3.8 3.8 0 1112 15.8 3.8 3.8 0 0112 8.2zm0 1.8a2 2 0 100 4 2 2 0 000-4zm5.1-2.7a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2z" />
  //     </svg>
  //   ),
  // },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/bps-analytics-pvt-ltd',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6" aria-hidden="true">
        <path d="M6.2 9.2H3.4V20h2.8V9.2zM4.8 4a1.6 1.6 0 100 3.2A1.6 1.6 0 004.8 4zM20.6 12.7c0-3.1-1.7-4.5-3.9-4.5-1.8 0-2.6 1-3.1 1.7V9.2H10.8c0 .9 0 10.8 0 10.8h2.8v-6c0-.3 0-.7.1-1 .3-.7.9-1.4 2-1.4 1.4 0 2 1.1 2 2.6V20h2.9v-7.3z" />
      </svg>
    ),
  },
  // {
  //   label: 'YouTube',
  //   href: '#',
  //   icon: (
  //     <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6" aria-hidden="true">
  //       <path d="M22.5 8.2a3 3 0 00-2.1-2.1C18.6 5.6 12 5.6 12 5.6s-6.6 0-8.4.5A3 3 0 001.5 8.2C1 10 1 12.5 1 12.5s0 2.5.5 4.3a3 3 0 002.1 2.1c1.8.5 8.4.5 8.4.5s6.6 0 8.4-.5a3 3 0 002.1-2.1c.5-1.8.5-4.3.5-4.3s0-2.5-.5-4.3zM10 15.2V9.8l5.2 2.7L10 15.2z" />
  //     </svg>
  //   ),
  // },
];

function Footer({ showCta = true }) {
  return (
    <footer id="contact" className="bg-brand-white">
      {showCta ? (
        <div className="mx-auto max-w-[1440px] px-6 pt-2 lg:px-10 lg:pt-2">
          <div className="relative w-full overflow-hidden rounded-2xl bg-brand-primary sm:aspect-[1024/250]">
            <img
              src="/images/footer-banner.png"
              alt=""
              className="absolute inset-0 hidden h-full w-full object-cover object-top sm:block"
              aria-hidden="true"
            />

            <div className="relative z-10 flex flex-col items-center px-5 py-8 text-center sm:h-full sm:max-w-[70%] sm:items-start sm:justify-center sm:px-8 sm:py-5 sm:text-left lg:max-w-[55%] lg:px-12">
              <h2 className="text-[22px] font-bold uppercase leading-[1.15] tracking-wide text-brand-white sm:text-[30px] lg:text-[36px]">
                Ready To Lead The Future?
              </h2>
              <p className="mt-2 max-w-sm text-[13px] text-brand-white/90 sm:mt-2 sm:max-w-none sm:text-body-sm lg:text-body">
                Join FutureLeadX today and transform your career.
              </p>

              <div className="mt-5 flex w-full max-w-[260px] flex-col gap-2.5 sm:mt-5 sm:max-w-none sm:flex-row sm:flex-wrap sm:gap-3">
                <a
                  href={ENROLL_FORM}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full rounded-md bg-brand-white px-4 py-2.5 text-center text-[13px] font-semibold text-brand-primary transition-colors hover:bg-brand-background sm:w-auto sm:px-5 sm:text-button"
                >
                  Enroll Now
                </a>
                <a
                  href={PARTNER_FORM}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full rounded-md border border-brand-white bg-transparent px-4 py-2.5 text-center text-[13px] font-semibold text-brand-white transition-colors hover:bg-brand-white/10 sm:w-auto sm:px-5 sm:text-button"
                >
                  Partner With Us
                </a>
                <a
                  href={ENROLL_FORM}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full rounded-md border border-brand-white bg-transparent px-4 py-2.5 text-center text-[13px] font-semibold text-brand-white transition-colors hover:bg-brand-white/10 sm:w-auto sm:px-5 sm:text-button"
                >
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {/* Footer columns — no QR (same as image 1 minus QR) */}
      <div className="mx-auto max-w-[1440px] px-6 py-6 lg:px-10 lg:py-10">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="max-w-[280px]">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/images/bps-logo.png"
                alt="BPS Group"
                className="h-14 w-14 object-contain"
              />
              <div>
                <p className="text-lg font-bold uppercase leading-tight text-brand-navy">
                  BPS GROUP
                </p>
                <p className="text-[10px] font-medium uppercase tracking-wide text-brand-muted">
                  Serving Excellence Since 2018
                </p>
              </div>
            </Link>
            <p className="mt-4 text-body-sm leading-relaxed text-brand-navy">
              An initiative empowering youth to become future industry leaders.
            </p>
          </div>

          <div>
            <h3 className="text-body font-bold text-brand-navy">Quick Links</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-body-sm text-brand-navy/80 transition-colors hover:text-brand-primary"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-body font-bold text-brand-navy">Resources</h3>
            <ul className="mt-4 space-y-2.5">
              {resources.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    download={link.download}
                    className="text-body-sm text-brand-navy/80 transition-colors hover:text-brand-primary"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-body font-bold text-brand-navy">Contact</h3>
            <ul className="mt-4 space-y-3 text-body-sm text-brand-navy/80">
              <li className="flex items-center gap-2.5">
                <svg viewBox="0 0 20 20" fill="currentColor" className="h-6 w-6 shrink-0 text-brand-primary" aria-hidden="true">
                  <path d="M2 3.5A1.5 1.5 0 013.5 2h2.1c.7 0 1.3.5 1.4 1.2l.4 2.2a1.5 1.5 0 01-.8 1.6l-1.1.5a11.05 11.05 0 005.3 5.3l.5-1.1a1.5 1.5 0 011.6-.8l2.2.4c.7.1 1.2.7 1.2 1.4v2.1A1.5 1.5 0 0116.5 16 13.5 13.5 0 012 3.5z" />
                </svg>
                <a href="tel:+911140244526" className="hover:text-brand-primary">
                  +91-11-40244526
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <svg viewBox="0 0 20 20" fill="currentColor" className="h-6 w-6 shrink-0 text-brand-primary" aria-hidden="true">
                  <path d="M3 4h14a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1zm0 2.2l7 4.4 7-4.4V5H3v1.2z" />
                </svg>
                <a href="mailto:info@bpsanalytics.in" className="hover:text-brand-primary">
                  info@bpsanalytics.in
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <img
                  src="/images/bps-logo.png"
                  alt=""
                  className="h-6 w-6 shrink-0 object-contain"
                  aria-hidden="true"
                />
                <a
                  href="https://www.bpsanalytics.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-brand-primary"
                >
                  www.bpsanalytics.in
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <svg viewBox="0 0 20 20" fill="currentColor" className="mt-0.5 h-6 w-6 shrink-0 text-brand-primary" aria-hidden="true">
                  <path d="M10 2a6 6 0 00-6 6c0 4.5 6 10 6 10s6-5.5 6-10a6 6 0 00-6-6zm0 8.2A2.2 2.2 0 1112.2 8 2.2 2.2 0 0110 10.2z" />
                </svg>
                <span>
                  Tower B, 3rd floor, Balaji Estate, 8 Guru Ravidas Marg,
                  <br />
                  Kalkaji, New Delhi - 110019
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar — LinkedIn here like image 1 */}
      <div className="border-t border-brand-border">
        <div className="mx-auto flex max-w-[1440px] flex-col items-center justify-between gap-4 px-6 py-4 sm:flex-row lg:px-10">
          <p className="text-label text-brand-muted">
            © 2026 BPS Group. All Rights Reserved.
          </p>
          <div className="flex items-center gap-3">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target={social.href.startsWith('http') ? '_blank' : undefined}
                rel={social.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-brand-navy/30 text-brand-navy transition-colors hover:border-brand-primary hover:text-brand-primary"
                aria-label={social.label}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
